
import { defineComponent, onMounted } from 'vue';
import { Form, defineRule } from 'vee-validate';
import { useRouter } from 'vue-router';
import AppHeader from '@/components/AppHeader.vue';
import AppInput from '@/components/UI/AppInput.vue';
import AppButton from '@/components/UI/AppButton.vue';
import ValidationService from '@/services/ValidationService';
import { PASSWORD_LENGTH } from '@/types/consts';
/* eslint-disable import/no-cycle */
import AuthService from '@/modules/auth/services/AuthService';
/* eslint-disable import/no-cycle */
import { useMainStore } from '@/store/mainStore';
import { IPassword } from '@/types/interfaces';
import MonitoringService from '@/services/MonitoringService';

defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');
defineRule(
  'min6',
  (value: string) => (ValidationService.isLonger(value, PASSWORD_LENGTH))
    || 'Password is not valid, should be not less then 6 characters',
);
defineRule('capital', (value: string) => ValidationService.containsCapitalLetter(value) || 'Password is not valid, should contain: 1 uppercase letter');
defineRule('special', (value: string) => ValidationService.containsSpecialCharacter(value) || 'Password is not valid, should contain: 1 special character');
defineRule('numeric', (value: string) => ValidationService.containsNumeric(value) || 'Password is not valid, should contain: 1 number');
defineRule('confirmed', (value: string, [other]:string) => (value === other) || 'Password dont match');

export default defineComponent({
  components: {
    Form, AppHeader, AppInput, AppButton,
  },
  setup() {
    const router = useRouter();
    const schema = {
      newPassword: 'required|min6|capital|special|numeric',
      confirmPassword: 'required|confirmed:@newPassword',
    };
    const mainStore = useMainStore();

    function onSubmit(values: any) {
      const { newPassword: password } = values;
      AuthService.changePassword({ password } as IPassword).then((response) => {
        if (response.success) {
          router.push('/password-reset-success');
        }
      });
    }

    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      schema,
      mainStore,
      onSubmit,
    };
  },
});
